import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import IconHelper from "../../Helpers/IconHelper";
import ServiceMenuData from "./ServiceMenuData";

const ServiceMenu1 = () => {
  const [menu, setMenu] = useState(false);
  const ref = useRef(null);

    const handleClickOutside = (e) => {
    if (!ref.current.contains(e.target)) {
      setMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });

  return (
    <li className="menu-has-children" id="desktop-service-menu" ref={ref}>
      {/* Not a link: this only opens the menu. A <Link to="#"> here renders
          href="<current page>" (react-router resolves "#" against the
          current URL), so right-click / open-in-new-tab / crawlers all saw
          a link to whatever page you were already on. The class keeps
          Bootstrap's `a:not([href]):not([class])` reset (color: inherit)
          from restyling it. */}
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a
        className="nav-label"
        role="button"
        tabIndex={0}
        aria-haspopup="true"
        aria-expanded={menu}
        style={{ cursor: "pointer" }}
        onClick={() => setMenu(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setMenu(true);
          }
        }}
      >
        Services
        <IconHelper.ChevronDown />
      </a>

      <ul
        style={{
          display: "none",
          ...(menu && { display: "block" }),
        }}
      >
        {ServiceMenuData.map((menuItem, index) =>
          menuItem.subMenuGroup.length === 1 ? (
            // A category with exactly one destination should just be that
            // link. Category labels below are non-navigating menu triggers;
            // when a label is also the only destination (Staff
            // Augmentation), visitors naturally click the label itself and
            // nothing happens, so render it as the real link instead.
            <li key={index}>
              <Link to={menuItem.subMenuGroup[0].route}>
                {menuItem.mainMenu}
              </Link>
            </li>
          ) : (
            <li className="menu-has-children" key={index}>
              {/* Non-navigating label: see the note on "Services" above. */}
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                className="nav-label"
                role="button"
                tabIndex={0}
                aria-haspopup="true"
                style={{ cursor: "pointer" }}
              >
                {menuItem.mainMenu}
              </a>
              <ul>
                {menuItem.subMenuGroup.map((menuSubItem, index) => (
                  <li key={index}>
                    <Link to={menuSubItem.route}>{menuSubItem.submenu}</Link>
                  </li>
                ))}
              </ul>
            </li>
          )
        )}
      </ul>
    </li>
  );
};

export default ServiceMenu1;
